import * as React from "react";
import type { SVGProps } from "react";

interface ResumeOvertimeProps extends SVGProps<SVGSVGElement> {
  cancelled?: boolean;
}
const ResumeOvertime = ({ cancelled = false, ...props }: ResumeOvertimeProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <g>
    <g fill="none" fillRule="evenodd">
      <g transform="translate(2.25 2.25)">
        <circle
          cx={7.5}
          cy={7.5}
          r={8.57}
          fill="#60B100"
          stroke="#FFF"
          strokeWidth={2.15}
        />
        <circle cx={7.5} cy={7.5} r={8.15} stroke="#000" strokeWidth={1.3} />
      </g>
      <path
        fill="#FFF"
        stroke="#000"
        strokeWidth={1.1}
        d="m7.5 4.3 7.35 5.05a.42.42 0 0 1 0 .69L7.5 15.08a.42.42 0 0 1-.66-.34V4.65a.42.42 0 0 1 .66-.35Z"
      />
      <g transform="translate(11.25 9.75)">
        <path
          fill="#FFF"
          fillRule="nonzero"
          d="M7.11 0c.66 0 1.22.5 1.3 1.2v.12c0 .27-.08.52-.22.73l-.05.06.14.05A6.22 6.22 0 0 1 12.5 7.8v.23c0 3.43-2.8 6.2-6.25 6.2A6.22 6.22 0 0 1 4.22 2.16l.14-.04-.05-.06a1.3 1.3 0 0 1-.21-.6l-.01-.13V1.3c0-.72.58-1.3 1.3-1.3z"
        />
        <path
          fill="#000"
          fillRule="nonzero"
          d="M5.39 1.87a.55.55 0 0 1-.55-.55V1.3c0-.3.25-.55.55-.55h1.72c.28 0 .51.21.55.49v.08c0 .3-.25.55-.55.55h-.44v.72a5.48 5.48 0 0 1 5.08 5.44 5.48 5.48 0 0 1-5.5 5.46 5.48 5.48 0 0 1-5.5-5.46 5.48 5.48 0 0 1 5.08-5.44v-.72z"
        />
        <circle cx={6.25} cy={8} r={4.5} fill="#FFF" />
      </g>
      <path
        fill="#60B100"
        d="M17.5 21.7a4.02 4.02 0 0 1-4.05-3.97c0-2.2 1.81-3.98 4.05-3.98z"
      />
      <g fillRule="nonzero">
        <path
          fill="#FFF"
          d="M20.15 0c.77 0 1.4.63 1.4 1.4v1.1h1.1c.73 0 1.33.56 1.4 1.27v.13c0 .77-.63 1.4-1.4 1.4h-1.1v1.1a1.4 1.4 0 0 1-1.27 1.4h-.13a1.4 1.4 0 0 1-1.4-1.4V5.3h-1.1a1.4 1.4 0 0 1-1.4-1.27V3.9c0-.77.63-1.4 1.4-1.4h1.1V1.4c0-.73.56-1.33 1.27-1.4z"
        />
        <path
          fill="#000"
          d="M20.15.75c.36 0 .65.3.65.65v1.85h1.85a.65.65 0 1 1 0 1.3H20.8V6.4a.65.65 0 1 1-1.3 0V4.55h-1.85a.65.65 0 1 1 0-1.3h1.85V1.4c0-.36.3-.65.65-.65"
        />
      </g>
    </g>
        {cancelled && (
        <rect
          width="25"
          height="2.5"
          x="-.494"
          y="10.746"
          fill="#000"
          fillRule="evenodd"
          stroke="#FFF"
          rx="1"
          transform="rotate(-45 12.006 11.996)"
        />
      )}
    </g>
  </svg>
);
export default ResumeOvertime;
